import { render, staticRenderFns } from "./GuardConfig.vue?vue&type=template&id=4583f4a7&"
import script from "./GuardConfig.vue?vue&type=script&lang=js&"
export * from "./GuardConfig.vue?vue&type=script&lang=js&"
import style0 from "./GuardConfig.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports